/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PieChart from 'loracoms/PieChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import { toDistrPieData } from '../selectors';


function toSeries(sfData) {
  const sum = _.sum(_.values(sfData));
  return {
    label: {
      normal: {
        formatter: '{b}: {d}%',
      },
      emphasis: {
        formatter: '{b}: {d}%',
      },
    },
    data: _.map(sfData, (value, name) => ({
      name,
      value,
      label: {
        normal: {
          position: value / sum < 0.1 ? 'outside' : 'inside',
          fontSize: 10,
        },
      },
      labelLine: {
        normal: {
          length: 5,
          length2: 5,
        },
      },
    })),
  };
}


const defaultProps = {
  resize: 0,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  sfData: React.PropTypes.object.isRequired,
  resize: React.PropTypes.number,
};

class GatewaySFPie extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sfData: props.sfData,
      resize: props.resize,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statschart');
  }

  componentWillReceiveProps(nextProps) {
    const { sfData, resize } = nextProps;
    if (sfData !== this.props.sfData) {
      this.setState({ sfData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize });
    }
  }

  render() {
    const { sfData, resize = 0 } = this.state;
    return (
      <div className={styles.chart}>
        <PieChart series={[toSeries(sfData)]} resize={resize} />
      </div>
    );
  }
}

GatewaySFPie.defaultProps = defaultProps;
GatewaySFPie.propTypes = propTypes;

const mapStateToProps = state => ({
  sfData: toDistrPieData('sf')(state),
});

export default connect(mapStateToProps, null)(injectIntl(GatewaySFPie));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewaySFPie/index.jsx